import * as angular from 'angular';
import * as _ from 'lodash';
import UserResource from '../models/user-resource';

export default class AuthService {
  private _currentUser: UserResource;

  constructor(
    private $http,
    private localStorageService,
    private apiUrl,
    private SiteSwitcherService,
    private JsonApiParser,
    private $rootScope,
    private $state
  ) {}

  private saveUser(user) {
    this.localStorageService.set('currentUser', user);
  }

  private saveAuthenticationInformation(response) {
    var user = this.JsonApiParser.parse(response.data);
    var sites = user.sites;
    user.sites = [];
    user.token = user.meta['auth-token'];

    if (user.token) {
      this.$http.defaults.headers.common.Authorization = user.token;
      this.saveUser(user);
      return this.SiteSwitcherService.saveSites(sites);
    } else {
      // That's an error
    }
  }

  currentUser() {
    // This call happens A LOT. Going to memoize this value
    if (_.isNil(this._currentUser)) {
      const user = this.localStorageService.get('currentUser');
      this._currentUser = !_.isNil(user) ? new UserResource(user) : undefined;
    }

    return this._currentUser;
  }

  hasPermission(model, action) {
    // TODO: properly determine manufacturer permissions on admin actions.
    if (this.currentUser().isSuperUser || this.currentUser().isManufacturer) {
      return true;
    }
    var site = this.SiteSwitcherService.currentSite();
    return _.find(site.permissions, { model: model, action: action });
  }

  isLoggedIn() {
    return angular.isObject(this.currentUser());
  }

  tokenLogin(token) {
    return this.$http
      .post(this.apiUrl + 'auth', { 'auth-token': token })
      .then(this.saveAuthenticationInformation.bind(this));
  }

  login(email, password) {
    return this.$http
      .post(this.apiUrl + 'auth', { email: email, password: password })
      .then(this.saveAuthenticationInformation.bind(this));
  }

  logout() {
    this.localStorageService.clearAll();
    this.$http.defaults.headers.common.Authorization = '';
    this._currentUser = undefined;
    this.$rootScope.$broadcast('userLoggedOut');
  }

  goHome() {
    this.$state.go(
      'app.epx.reports',
      { siteId: this.SiteSwitcherService.currentSite().id },
      { location: 'replace' }
    );
  }
}

angular
  .module('ciApp.services')
  .service('AuthService', [
    '$http',
    'localStorageService',
    'apiUrl',
    'SiteSwitcherService',
    'JsonApiParser',
    '$rootScope',
    '$state',
    AuthService
  ]);



// WEBPACK FOOTER //
// ./common/services/auth.service.ts